


























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import TemplatesModule from "@/store/modules/templates";
import Template from "@/models/template";
import ConfigurationItemGroup from "@/components/ConfigurationItemGroup.vue";
import { IItemSection } from "@/models/itemSection";

@Component({
  components: {
    ConfigurationItemGroup
  }
})
export default class ConfigurationMenu extends Vue {
  @Prop({ type: Boolean, required: true }) visibility!: Boolean;
  @Prop({ type: Array, required: true }) sections!: IItemSection[];

  @Watch("visibility", { immediate: true, deep: true })
  onVisibilityChange(isVisible: Boolean) {}
}
